import script from "./xt_ripple.vue?vue&type=script&setup=true&lang=js"
export * from "./xt_ripple.vue?vue&type=script&setup=true&lang=js"

import "./xt_ripple.vue?vue&type=style&index=0&id=125fc7af&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-125fc7af"]])

export default __exports__